import { useState, useEffect } from "react";
import "./Testimonials.css";

export default function Testimonials() {
  // ⭐ Dynamic reviews data
  const reviews = [
    {
      text: "An unforgettable dining experience! Every dish was a masterpiece, and the ambiance was simply perfect. From the first bite to the last, every moment was pure culinary bliss. Highly recommended!",
      name: "VIKTORIA F.",
      avatars: [
        "https://randomuser.me/api/portraits/women/44.jpg",
        "https://randomuser.me/api/portraits/women/65.jpg",
        "https://randomuser.me/api/portraits/men/22.jpg",
      ],
      image:
        "https://images.unsplash.com/photo-1551218808-94e220e084d2?auto=format&fit=crop&w=1200&q=80",
    },
    {
      text: "Amazing food and top-notch service! The flavors were rich, the ingredients fresh, and the atmosphere warm and inviting. I will definitely be coming back again and again!",
      name: "JULIA M.",
      avatars: [
        "https://randomuser.me/api/portraits/women/12.jpg",
        "https://randomuser.me/api/portraits/men/41.jpg",
        "https://randomuser.me/api/portraits/men/33.jpg",
      ],
      image:
        "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&w=1200&q=80",
    },
    {
      text: "Best dining experience ever! Beautiful ambiance and excellent service. Every dish was bursting with flavor and creativity!",
      name: "ANDREW T.",
      avatars: [
        "https://randomuser.me/api/portraits/men/55.jpg",
        "https://randomuser.me/api/portraits/women/34.jpg",
        "https://randomuser.me/api/portraits/men/72.jpg",
      ],
      image:
        "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=1200&q=80",
    },
  ];

  const [index, setIndex] = useState(0);

  // ⭐ Auto-slide every 6 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % reviews.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const current = reviews[index];

  return (
    <section className="ts-testimonial-section">
      <div className="ts-testimonial-box">
        <p className="ts-review-label">REVIEWS</p>
        <h2 className="ts-title">Testimonials</h2>

        <div className="ts-quote">“</div>

        <p className="ts-text">{current.text}</p>

        <div className="ts-avatars">
          {current.avatars.map((img, i) => (
            <img key={i} src={img} alt="" />
          ))}
        </div>

        <p className="ts-name">{current.name}</p>
      </div>

      <div className="ts-right-image">
        <img src={current.image} alt="Review" />
      </div>
    </section>
  );
}
